import axiosClientNotLogin from "api/axiosClientNotLogin";


const PREFIX_URL = "client/cau-hinh";

const configClientApi = {
    getAllMenuConfig: (params) => {
        const url = `${PREFIX_URL}/getAllMenuConfig`;
        return axiosClientNotLogin.get(url, { params });
    },
}

export default configClientApi;
